<template>
  <b-collapse class="evaluation-card" animation="slide" :open="isOpen" data-cy="associated-insurance-data">
    <template #trigger="{ open }">
      <div class="card-header" role="button" :aria-expanded="open.toString()">
        <p class="card-header-title">
          Seguros asociados
        </p>
        <a class="card-header-icon">
          <b-icon :icon="open ? 'minus' : 'plus'" />
        </a>
      </div>
    </template>
    <div class="card-block">
      <b-field label="Cuota seguro de crédito" horizontal class="has-addons">
        <div class="field has-addons">
          <p class="control">
            <a class="button is-static">UF</a>
          </p>
          <b-input
            v-model="simulation.offerResponse.creditInsuranceFee"
            :disabled="readOnly"
            size="is-small"
            type="number"
            placeholder="Ingresa valor en UF"
            expanded />
        </div>
      </b-field>

      <b-field label="Cuota seg. desgravamen" horizontal class="has-addons">
        <div class="field has-addons">
          <p class="control">
            <a class="button is-static">UF</a>
          </p>
          <b-input
            v-model="simulation.offerResponse.lifeInsuranceFee"
            :disabled="readOnly"
            size="is-small"
            type="number"
            placeholder="Ingresa valor en UF"
            expanded />
        </div>
      </b-field>

      <b-field label="Cuota seg. de propiedad" horizontal class="has-addons">
        <div class="field has-addons">
          <p class="control">
            <a class="button is-static">UF</a>
          </p>
          <b-input
            v-model="simulation.offerResponse.propertyInsuranceFee"
            :disabled="readOnly"
            size="is-small"
            type="number"
            placeholder="Ingresa valor en UF"
            expanded />
        </div>
      </b-field>

      <b-field label="Cuota seg. cesantía" horizontal class="has-addons">
        <div class="field has-addons">
          <p class="control">
            <a class="button is-static">UF</a>
          </p>
          <b-input
            v-model="simulation.offerResponse.unemploymentInsuranceFee"
            :disabled="readOnly"
            size="is-small"
            type="number"
            placeholder="Ingresa valor en UF"
            expanded />
        </div>
      </b-field>
    </div>
  </b-collapse>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AssociatedInsuranceCard',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('evaluation', ['simulation'])
  }
};
</script>

<style scoped>
</style>
